<template>
<div id="EDSHome"> 
<Subtitle  v-bind:ServiceID="this.AppServiceID" v-bind:MainPage="true">
   <template v-slot:header> 
    <i class="fa fa-medkit"></i><b>EDS Home:</b>
  </template> 
</Subtitle>
  <Card>
<CardBody>
  <p>Any personal health information accessed through the Limited Access Exception Drug Status (EDS) Application is the property of the Government of Saskatchewan. Access to the contents of this site except by agencies <b>AUTHORIZED BY SASKATCHEWAN HEALTH IN WRITING</b> or their authorized employees is strictly prohibited. All transactions are monitored, logged and reviewed. 
  </p>
  <TileNote>
    <strong>Please Note:</strong> Legal action will be taken against any person accessing information without prior approval from Saskatchewan Health AND THOSE WHO UTILIZE THE INFORMATION FOR UNAUTHORIZED OR UNLAWFUL PURPOSES. 
  </TileNote>
 </CardBody>
</Card>

</div>
</template>

<script>
import {mapGetters} from 'vuex';
import Subtitle from '@/Common/Default/SubTitle.vue';  
import LayoutDefault from '@/Common/Default/DefaultLayout.vue'; 
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
export default {


    components: { 
            Card,
            CardBody,
            TileNote ,
            Subtitle
        },
    created: function() {
      //console.log(' i am here ')
      this.$emit('update:layout', LayoutDefault);
      const auth = this.$store.getters.IsAuth;
      //console.log(' is auth at eds home ' + auth)
      this.AppServiceID =this.$store.getters.GetDentalID;
      if (auth) { 
        
        this.dateFormat = this.$store.getters.GetDateFormat; 
       
       //console.log('home app service id  = ' + this.AppServiceID)
      }
      //console.log('home app service id  = ' + this.AppServiceID)
    },
    beforeCreate: function() {  
      //console.log('at before')
        this.$store.dispatch('AddServiceID',this.$store.getters.GetDentalID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetDentalID); 
    },
     
}
</script>

<style>

</style>